import React from 'react';
import classnames from 'classnames';

import s from '../../MapSidebarResults.module.scss';
import { TSidebarSubTabProps } from 'src/components/MapSidebar/components/MapSidebarResults/components/SidebarSubTab/SidebarSubTab.types';

export const SidebarSubTab: React.FC<TSidebarSubTabProps> = ({ tabs }) => (
  <div className={classnames(s.subtabHeader)}>
    <ul className={s.headerNav}>
      {tabs.map((item) => (
        <li
          key={`sidebarSubTabItem-${item.label}-${item.liTitle}`}
          className={classnames(s.communityName, {
            [s.active]: item.isActive(),
          })}
          title={item.liTitle}>
          <button type="button" onClick={item.onClick}>
            {item.label}
          </button>
        </li>
      ))}
    </ul>
  </div>
);
